import { createFileRoute } from '@tanstack/react-router'
import RefundPolicyPage from '@/pages/refund-policy'
import { buildHead } from '@/shared/seo/seo-config'

export const Route = createFileRoute('/$lang/refund-policy')({
  head: ({ params }) => buildHead('refund', params.lang),
  component: RefundPolicyPage,
  staticData: { layout: 'public' },
})
